export default __webpack_public_path__ + "static/media/Thumb_Shoes_05.20aafe3b.png";